export default (props) => {
	
	let {
		tourPackage,
		customizedTour,
		name,
		emailAddress,
		contactNumber,
		message
	} = props;

	return `<table style="width: 80%; margin: 0 auto; min-width: 400px; border-spacing:0;" cellspacing="0" cellpadding="0">
		<tr>
			<td colSpan="2" style="color:#f39926; font-weight:bold; font-size:23px;">
				<label>Light Miles Travel Inquiry</label>
			</td>				
		</tr>
		<tr>
			<td style="border:1px solid #f1f1f1; padding:10px;">
				<label style="font-weight: bold; font-size: 14px; color: #333;">Tour Package:</label><br> 
				<label style="font-size: 18px; color: #333;">${tourPackage}</label>
			</td>
		</tr>
		<tr>
			<td style="border:1px solid #f1f1f1; padding:10px;">
				<label style="font-weight: bold; font-size: 14px; color: #333;">Customized tour:</label><br> 
				<label style="font-size: 18px; color: #333;">${customizedTour}</label>
			</td>
		</tr>
		<tr>
			<td style="border:1px solid #f1f1f1; padding:10px;">
				<label style="font-weight: bold; font-size: 14px; color: #333;">Client's Name:</label><br> 
				<label style="font-size: 18px; color: #333;">${name}</label>
			</td>
		</tr>
		<tr>
			<td style="border:1px solid #f1f1f1; padding:10px;">
				<label style="font-weight: bold; font-size: 14px; color: #333;">E-mail address:</label><br> 
				<label style="font-size: 18px; color: #333;">${emailAddress}</label>
			</td>
		</tr>
		<tr>
			<td style="border:1px solid #f1f1f1; padding:10px;">
				<label style="font-weight: bold; font-size: 14px; color: #333;">Contact Number:</label><br> 
				<label style="font-size: 18px; color: #333;">${contactNumber}</label>
			</td>
		</tr>
		<tr>
			<td style="border:1px solid #f1f1f1; padding:10px;">
				<label style="font-weight: bold; font-size: 14px; color: #333;">Message:</label><br> 
				<label style="font-size: 18px; color: #333;">${message}</label>
			</td>					
		</tr>
	</table>`;
}